import { Reveal } from "./Reveal";

export const PullQuote = () => (
  <section data-testid="pull-quote-section" className="bg-white pb-28 sm:pb-36 px-6">
    <div className="max-w-4xl mx-auto text-center">
      <Reveal>
        <span className="block w-16 h-px bg-[#C5A059] mx-auto" />
        <blockquote className="font-serif-accent italic font-light mt-12 text-2xl sm:text-3xl lg:text-4xl leading-snug text-[#0B1B3D]">
          “Veteran-led, well-capitalized, and built for speed — DPM offers sellers a credible,
          straightforward path forward.”
        </blockquote>
      </Reveal>
    </div>
  </section>
);
